import _ from "lodash";
import { useContext, useEffect, useState } from "react";
import ConfigurationViewPage from "../../../components/management/PartnerGenericConfigurationPages/ConfigurationViewPage";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { paths } from "../../../routes/paths";
import "./OutcomeConfigurationViewPage.scss";

export default function OutcomeConfigurationViewPage() {
  const [configData, setConfigData] = useState({
    points: "",
    limit: "",
  });
  const { programConfigurations } = useContext(GlobalConfigContext);

  const configKey = "global_outcomes";
  const editPath = `/${paths.system_setting}/${paths.global_outcomes}/edit`;

  useEffect(() => {
    const configuration = _.find(programConfigurations, {
      key: configKey,
    });
    if (configuration !== null && configuration !== undefined) {
      setConfigData(configuration.value?.data);
    }
  }, [programConfigurations]);

  const breadcrumbPath = [
    {
      href: "/",
      label: "Home",
    },
    {
      label: "Program Settings",
      href: `../../../${paths.system_setting}`,
    },
    {
      label: "Global Outcomes View",
      href: `../../../${paths.system_setting}/${paths.global_outcomes}`,
    },
  ];

  return (
    <ConfigurationViewPage
      configKey={configKey}
      headerText="Global Outcomes View"
      description="Global configuration for the portal."
      breadcrumbPath={breadcrumbPath}
      editPath={editPath}
    >
      <h5 className="$color-text-primary">
        Points: <span className="value">{configData.joy_points?.points}</span>
      </h5>
      <h5 className="$color-text-primary">
        Limit: <span className="value">{configData.joy_points?.limit}</span>
      </h5>
    </ConfigurationViewPage>
  );
}
